module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pleg31-4fa6421fa4e183cf5d33f2a44d940676.jpg";